export default __webpack_public_path__ + "static/media/GroupCVV -4@2x.d5617134.png";